.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main {
  flex: 1;
  width: 100%;
  padding-top: var(--space-6);
  padding-bottom: var(--space-6);
}

@media (min-width: 768px) {
  .main {
    padding-top: var(--space-8);
    padding-bottom: var(--space-8);
  }
}